import React, { useEffect, useState } from 'react'
import Kotak from '../Images/kotak.svg'
import HDFC from "../Images/hdfc.svg"
import Paytm from "../Images/paytm.svg"
import Axis from '../Images/axis.png'
import kotakImg from '../Images/Arrow-white.svg'
import cholaLogo from '../Images/Cholamandalam_logo.svg'
import Lang from '../Images/lang.svg'
import { useNavigate } from 'react-router-dom'
import Digio from '../Images/digio.svg'
import Loader from './Loader'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { setLoggedIn, setMandateData, setOtpTriggered, setPartnerName, setShowLanguage, setmandateIdType } from './MandateSlice'
import EMandate from '../Images/EMandate.svg'
import UpiMandate from '../Images/UPIMandate.svg'
import AadhaarMandate from '../Images/AadharMandate.svg'
import PhysicalMandate from '../Images/PhysicalMandate.svg'
import iciciImg from '../Images/icici.svg'

function PaymentSystem() {
    const dispatch = useDispatch()
    const { mandateID } = useSelector((state) => state.mandateInfo);
    const { mandateData, mandate, partner } = useSelector((state) => state.mandateInfo);
    const navigate = useNavigate()
    const [type, setType] = useState()
    const [mandateOptType, setMandateOptType] = useState()
    const KotakUPI = () => {
        if (type === 'paytm-upi-mandate' || type === 'hdfc-upi-mandate' || type === 'kotak-upi-mandate') {
            navigate('/upi-mandate')
        }
        else {
            navigate('/e-mandate')
        }
    }
    const showMandate = () => {
        setMandateType(mandateOptType)
    }
    const setMandate = (type) => {
        dispatch(setPartnerName(type))
        if (type === 'kotak' && mandate === 'upi-mandate') {
            dispatch(setmandateIdType('upi-mandate'))
            navigate('/upi-mandate')
        }
        else if (type === 'hdfc' && mandate === 'upi-mandate') {
            dispatch(setmandateIdType('hdfc-upi-mandate'))
            navigate('/upi-mandate')
        }
        else if (type === 'axis' && mandate === 'e-mandate') {
            dispatch(setmandateIdType('axis-e-mandate'))
            navigate('/e-mandate')
        }
        else if (type === 'hdfc' && mandate === 'e-mandate') {
            dispatch(setmandateIdType('hdfc-e-mandate'))
            navigate('/e-mandate')
        }
        else if (type === 'icici' && mandate === 'upi-mandate') {
            dispatch(setmandateIdType('icici-upi-mandate'))
            navigate('/upi-mandate')
        }
        else if (type === 'paytm' && mandate === 'upi-mandate') {
            dispatch(setmandateIdType('paytm-upi-mandate'))
            navigate('/upi-mandate')
        }
        else if (type === 'digio' && mandate === 'upi-mandate') {
            dispatch(setmandateIdType('digio-upi-mandate'))
            navigate('/e-mandate')
        }
        else if (type === 'digio' && mandate === 'e-mandate') {
            dispatch(setmandateIdType('digio-e-mandate'))
            navigate('/e-mandate')
        }
        else if (type === 'kotak' && mandate === 'e-mandate') {
            dispatch(setmandateIdType('web-e-mandate'))
            navigate('/e-mandate')
        }
        else if (type === 'kotak' && mandate === 'aadhaar-mandate') {
            dispatch(setmandateIdType('web-a-mandate'))
            navigate('/e-mandate')
        }
        else if (type === 'kotak' && mandate === 'web-p-mandate') {
            dispatch(setmandateIdType('web-p-mandate'))
            navigate('/e-mandate')
        }
    }
    const logout = () =>{
        dispatch(setOtpTriggered(false))
        dispatch(setLoggedIn(false))
        navigate('/login')
    }
    useEffect(()=>{
        if(Object.keys(mandateData).length === 0){
            navigate('/payment')
        }
    },[mandateData])
    // useEffect(() => {
    //     axios({
    //         url: process.env.REACT_APP_RESPONSE,
    //         method: 'post',
    //         headers: {
    //             "Access-Control-Allow-Origin": "*",
    //             'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
    //         },
    //         data: { 'unique_id': mandateID }
    //     }).then((res) => { res ? dispatch(setMandateData(res?.data)) : dispatch(setMandateData()) })
    // }, [mandateID])
    const [mandateType, setMandateType] = useState(false)
    return (
        <>
            {!mandateType &&
                <div class="container in-spacer">
                    <div class="row selectdiv">
                        <div class="col-12">
                            <h6 class="mb-3">Select the Sponsor Bank</h6>
                        </div>
                        {((mandateData?.kotak && ((mandate === 'upi-mandate' && mandateData?.kotak_upi) || mandate === 'e-mandate' || mandate === 'aadhaar-mandate' || mandate === 'web-p-mandate'))) && <div className="col-lg-4 col-sm-4 col-6">
                            <div className="customRadio">
                                <input type="radio" name="role" id="kotak" value="kotak" onClick={() => { setMandate("kotak") }} />
                                <label htmlFor="kotak">
                                    <div className="pyIcons2"> <img className="face" src={Kotak} alt="" /> </div>
                                    <div className='mt-2'>
                                        {/* {mandateData?.upi_mandate && <div className="circleborder me-1"><img className="face" src={UpiMandate} /></div>}
                                        {mandateData?.e_mandate && <div className="circleborder me-1"><img className="face" src={EMandate} /></div>}
                                        {mandateData?.aadhaar_mandate && <div className="circleborder me-1"><img className="face" src={AadhaarMandate} /></div>}
                                        {mandateData?.physical_mandate && <div className="circleborder me-1"><img className="face" src={PhysicalMandate} /></div>} */}
                                    </div>
                                </label>
                            </div>
                        </div>}
                        {(mandateData?.digio && (mandate === 'e-mandate' || mandate === 'upi-mandate')) && <div className="col-lg-4 col-sm-4 col-6">
                            <div className="customRadio">
                                <input type="radio" name="role" id="digio" value="digio" onClick={() => { setMandate("digio") }} />
                                <label htmlFor="digio">
                                    <div className="pyIcons2"> <img className="face" src={Digio} alt="" /> </div>
                                    <div className='mt-2'>
                                        {/* {mandateData?.upi_mandate && <div className="circleborder me-1"><img className="face" src={UpiMandate} /></div>}
                                        {mandateData?.e_mandate && <div className="circleborder me-1"><img className="face" src={EMandate} /></div>} */}
                                        {/* {mandateData?.aadhaar_mandate && <div className="circleborder mx-2"><img className="face" src={AadhaarMandate} /></div>}
                                        {mandateData?.physical_mandate && <div className="circleborder mx-2"><img className="face" src={PhysicalMandate} /></div>} */}
                                    </div>
                                </label>
                            </div>
                        </div>}
                        {(mandateData?.icici && mandate === 'upi-mandate') && <div className="col-lg-4 col-sm-4 col-6">
                            <div className="customRadio" >
                                <input type="radio" name="role" id="icici" value="paytm" onClick={() => { setMandate("icici") }} />
                                <label htmlFor="icici">
                                    <div className="pyIcons2"> <img className="face" src={iciciImg} alt="" /> </div>
                                    <div className='mt-2'>
                                        {/* {mandateData?.upi_mandate && <div className="circleborder me-1"><img className="face" src={UpiMandate} /></div>} */}
                                        {/* {mandateData?.e_mandate && <div className="circleborder mx-2"><img className="face" src={EMandate} /></div>}
                                        {mandateData?.aadhaar_mandate && <div className="circleborder mx-2"><img className="face" src={AadhaarMandate} /></div>}
                                        {mandateData?.physical_mandate && <div className="circleborder mx-2"><img className="face" src={PhysicalMandate} /></div>} */}
                                    </div>
                                </label>
                            </div>
                        </div>}
                        
                        {(mandateData?.paytm && mandate === 'upi-mandate') && <div className="col-lg-4 col-sm-4 col-6">
                            <div className="customRadio" >
                                <input type="radio" name="role" id="paytm" value="paytm" onClick={() => { setMandate("paytm") }} />
                                <label htmlFor="paytm">
                                    <div className="pyIcons2"> <img className="face" src={Paytm} alt="" /> </div>
                                    <div className='mt-2'>
                                        {/* {mandateData?.upi_mandate && <div className="circleborder me-1"><img className="face" src={UpiMandate} /></div>} */}
                                        {/* {mandateData?.e_mandate && <div className="circleborder mx-2"><img className="face" src={EMandate} /></div>}
                                        {mandateData?.aadhaar_mandate && <div className="circleborder mx-2"><img className="face" src={AadhaarMandate} /></div>}
                                        {mandateData?.physical_mandate && <div className="circleborder mx-2"><img className="face" src={PhysicalMandate} /></div>} */}
                                    </div>
                                </label>
                            </div>
                        </div>}
                        {(mandateData?.hdfc && (mandate === 'upi-mandate' || mandate === 'e-mandate')) && <div className="col-lg-4 col-sm-4 col-6">
                            <div className="customRadio">
                                <input type="radio" name="role" id="hdfc" value="hdfc" onClick={() => { setMandate("hdfc") }} />
                                <label htmlFor="hdfc">
                                    <div className="pyIcons2"> <img className="face" src={HDFC} alt="" /> </div>
                                    <div className='mt-2'>
                                        {/* {mandateData?.upi_mandate && <div className="circleborder me-1"><img className="face" src={UpiMandate} /></div>} */}
                                        {/* {mandateData?.e_mandate && <div className="circleborder mx-2"><img className="face" src={EMandate} /></div>}
                                        {mandateData?.aadhaar_mandate && <div className="circleborder mx-2"><img className="face" src={AadhaarMandate} /></div>}
                                        {mandateData?.physical_mandate && <div className="circleborder mx-2"><img className="face" src={PhysicalMandate} /></div>} */}
                                    </div>
                                </label>
                            </div>
                        </div>}
                        {(mandateData?.axis && mandate === 'e-mandate') && <div className="col-lg-4 col-sm-4 col-6">
                            <div className="customRadio">
                                <input type="radio" name="role" id="axis" value="axis" onClick={() => { setMandate("axis") }} />
                                <label htmlFor="axis">
                                    <div className="pyIcons2"> <img className="face" src={Axis} alt="" /> </div>
                                    <div className='mt-2'>
                                        {/* {mandateData?.upi_mandate && <div className="circleborder me-1"><img className="face" src={UpiMandate} /></div>} */}
                                        {/* {mandateData?.e_mandate && <div className="circleborder mx-2"><img className="face" src={EMandate} /></div>}
                                        {mandateData?.aadhaar_mandate && <div className="circleborder mx-2"><img className="face" src={AadhaarMandate} /></div>}
                                        {mandateData?.physical_mandate && <div className="circleborder mx-2"><img className="face" src={PhysicalMandate} /></div>} */}
                                    </div>
                                </label>
                            </div>
                        </div>}
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <nav class="navbar MenuTop fixed-top navbar-expand-lg navstyles">
                                <div class="container">
                                    <a class="navbar-brand-sm" href="#">
                                        <img src={cholaLogo} alt="Chola Logo"/>
                                    </a>
                                    <ul class="nav-list">
                                        <li class="nav-item">
                                            {/* <a class="nav-link" onClick={() => { dispatch(setShowLanguage(true)) }}>
                                                <img src={Lang}/>
                                            </a> */}
                                        </li>
                                        {partner === 'chola-web' && <li>
                                        <a href="#" onClick={logout}>Logout</a>
                                    </li>}
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
                // <div className="container">
                //     <div class="row">
                //         <div class="col-12 text-center mt-4 mb-4"> <img src="assets/Images/chola_logo.svg" class="img-fluid" alt="" />
                //             <p class="Pay_way mt-3">Cholamandalam Investment and <br />
                //                 Finance Company Limited</p>
                //         </div>
                //     </div>
                //     <div className="row">
                //         <div className="col-6 mb-3">
                //             <div className="UPI_Mandate text-center">
                //                 <div className="form-check">
                //                     <input className="form-check-input" type="radio" onChange={() => { setMandateOptType('paytm') }} name="flexRadioDefault" id="Pay_radio" />
                //                     <label className="form-check-label" for="flexRadioDefault1">  </label>
                //                 </div>
                //                 <div className="pyIcons"> <img class="face" src={Paytm} /> </div>
                //             </div>
                //         </div>
                //         <div className="col-6 mb-3">
                //             <div className="UPI_Mandate text-center">
                //                 <div className="form-check">
                //                     <input className="form-check-input" onChange={() => { setMandateOptType('hdfc') }} type="radio" name="flexRadioDefault" id="Pay_radio" />
                //                     <label className="form-check-label" for="flexRadioDefault1">   </label>
                //                 </div>
                //                 <div className="pyIcons"> <img className="face" src={HDFC} /> </div>
                //             </div>
                //         </div> <div className="col-6 mb-3">
                //             <div className="UPI_Mandate text-center">
                //                 <div className="form-check">
                //                     <input className="form-check-input" onChange={() => { setMandateOptType('kotak') }} type="radio" name="flexRadioDefault" id="Pay_radio" />
                //                     <label className="form-check-label" for="flexRadioDefault1">   </label>
                //                 </div>
                //                 <div className="pyIcons"> <img class="face" src={Kotak} /> </div>
                //             </div>
                //         </div>
                //         <div className="d-grid gap-2 ">
                //             <button className="btn btn-primary Proceed_btn" onClick={showMandate}>Proceed</button>
                //         </div>
                //     </div>
                // </div>
            }
            {mandateType && <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="Pay_way">Powered by Paytm</div>
                    </div>
                </div>
                <div className="row">
                    <>
                        {mandateType === 'paytm' && <a>
                            <div className="col-12 mb-3">
                                <div className="d-flex justify-content-between align-items-center UPI_Mandate">
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="Pay_radio" onClick={() => { setType('paytm-upi-mandate') }} />
                                        <label className="form-check-label" htmlFor="flexRadioDefault1"> UPI Mandate </label>
                                    </div>
                                    <div className="circleborder"> <img class="face" src={Paytm} /> </div>
                                </div>
                            </div>
                        </a>}
                        {mandateType === "hdfc" && <div className="col-12 mb-3">
                            <div className="col-12 mb-3">
                                <div className="d-flex justify-content-between align-items-center UPI_Mandate">
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="flexRadioDefault" onClick={() => { setType('hdfc-upi-mandate') }} id="Pay_radio" />
                                        <label className="form-check-label" htmlFor="flexRadioDefault1"> UPI Mandate </label>
                                    </div>
                                    <div className="circleborder"> <img className="face" src={HDFC} /> </div>
                                </div>
                            </div>
                        </div>}
                        {mandateType === "kotak" &&
                            <>
                                <div className="col-12">
                                    <div className="Pay_way">Powered by Kotak</div>
                                </div>
                                <div className=" col-12 mt-3 ">
                                    <div className="Kotak_Mandate">
                                        <ul className="list-group">
                                            <li className="list-group-item borderless">
                                                <div className=" d-flex justify-content-between align-items-center ">
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="Pay_radio" onClick={() => { setType('kotak-upi-mandate') }} />
                                                        <label className="form-check-label" htmlFor="flexRadioDefault1"> UPI Mandate </label>
                                                    </div>
                                                    <div className="Kotak-circleborder"> <img src={Kotak} /> </div>
                                                </div>
                                            </li>
                                            <li className="list-group-item borderless">
                                                <div className=" d-flex justify-content-between align-items-center">
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="Pay_radio" onClick={() => { setType('web-e-mandate') }} />
                                                        <label className="form-check-label" htmlFor="flexRadioDefault1"> e Mandate </label>
                                                    </div>
                                                    <div className="Kotak-circleborder"> <img src={Kotak} /> </div>
                                                </div>
                                            </li>
                                            <li className="list-group-item borderless">
                                                <div className=" d-flex justify-content-between align-items-center ">
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="Pay_radio" onClick={() => { setType('web-a-mandate') }} />
                                                        <label className="form-check-label" htmlFor="flexRadioDefault1"> Aadhar Mandate </label>
                                                    </div>
                                                    <div className="Kotak-circleborder"> <img src={Kotak} /> </div>
                                                </div>
                                            </li>
                                            <li className="list-group-item border-0 ">
                                                <div className="d-flex justify-content-between align-items-center ">
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="Pay_radio" />
                                                        <label className="form-check-label" 
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => { setType('web-p-mandate') }}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                                        e.preventDefault();
                                                                                        setType('web-p-mandate') 
                                                                                    }
                                                                                }} htmlFor="flexRadioDefault1"> Physical Mandate </label>
                                                    </div>
                                                    <div className="Kotak-circleborder"> <img src={Kotak} /> </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </>}
                    </>
                    <div className="d-grid gap-2 ">
                        <button className="btn btn-primary Proceed_btn" type="button" onClick={() => KotakUPI()} disabled={!type}>Proceed</button>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default PaymentSystem